import { ReactNode } from 'react'
import { SearchBar } from '@/src/components/search-bar/SearchBar'

type SearchComponentProps = {
  query: string
  setQuery: (value: string) => void
  searchLabel: string
  error: unknown
  children: ReactNode
  startSearchLabel: string
}

const SearchComponent = ({
  query,
  setQuery,
  searchLabel,
  error,
  children,
  startSearchLabel,
}: SearchComponentProps) => {
  return (
    <>
      <div className="sticky top-0 z-50 bg-white px-5 pt-5 pb-3 rounded-t-2xl">
        <SearchBar label={searchLabel} value={query} onChange={setQuery} />
      </div>

      {!query && (
        <div className="flex flex-col items-center h-full justify-center gap-3">
          <img alt="group-svg" src="/icons/group.svg" width={88} height={88} />
          <span className="text-center px-5">{startSearchLabel}</span>
        </div>
      )}
      <div className="flex-1 overflow-y-auto px-5 pb-6 flex flex-col">{!error && children}</div>
    </>
  )
}

export default SearchComponent
